<template>
    <section class="phototheque-category">
        <h2 class="phototheque-category__title" v-html="name"></h2>
        <div class="row">
            <slot></slot>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'PhotothequeCategory',

        props: {
            name: { type: String, required: true },
        },
    };
</script>

<style scoped lang="scss">
    @import '../../assets/styles/abstracts/variables';

    .phototheque-category {
        padding-top: 2.2rem;

        color:       $gray-500;

        @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
            margin-bottom: 4rem;
            padding-top:   3rem;
        }

        &:not(:first-of-type) {
            border-top: 0.1rem solid $gray-300;
        }

        &:last-child {
            margin-bottom: 2rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                margin-bottom: 10rem;
            }
        }

        &__title {
            margin-bottom: 1.2rem;

            font-size:     2rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                margin-bottom: 2.1rem;

                font-size:     3rem;
            }
        }

        &__column {
            display:     flex;
            align-items: stretch;
        }
    }
</style>
